var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationDesignation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FBBF24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2063 17.5588C18.2063 18.5644 17.3882 19.3826 16.3825 19.3826H15.653C14.6474 19.3826 13.8292 18.5644 13.8292 17.5588V17.0785L9.06665 14.422V20.7366C9.06665 21.3399 9.55754 21.8308 10.1609 21.8308H21.839C22.4424 21.8308 22.9333 21.3399 22.9333 20.7366V14.4596L18.2063 17.0792V17.5588Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3826 18.6529C16.986 18.6529 17.4769 18.1621 17.4769 17.5587V15.9829H14.5588V17.5587C14.5588 18.1621 15.0497 18.6529 15.6531 18.6529H16.3826Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.839 11.8977H19.4968L19.3646 11.0813C19.3643 11.08 19.3642 11.0788 19.3639 11.0775C19.2428 10.3759 18.6382 9.8667 17.9262 9.8667H14.145C13.433 9.8667 12.8284 10.3759 12.7072 11.0775C12.707 11.0788 12.7068 11.08 12.7066 11.0813L12.5744 11.8977H10.1609C9.55754 11.8977 9.06665 12.3886 9.06665 12.992V13.5867L13.8292 16.2431V15.6182C13.8292 15.4168 13.9925 15.2535 14.194 15.2535H17.8416C18.043 15.2535 18.2063 15.4168 18.2063 15.6182V16.2451L22.9333 13.6255V12.992C22.9333 12.3886 22.4424 11.8977 21.839 11.8977ZM13.3134 11.8977L13.4264 11.1999C13.4877 10.85 13.7896 10.5962 14.145 10.5962H17.9262C18.2816 10.5962 18.5836 10.85 18.6448 11.2L18.7578 11.8977H13.3134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationDesignation);
export default __webpack_public_path__ + "static/media/OrganizationDesignation.426f27121d76d89296af4f2fa70bb17c.svg";
export { ForwardRef as ReactComponent };